/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  getOverrideProps,
  useNavigateAction,
} from "@aws-amplify/ui-react/internal";
import { Divider, Flex, Icon, Image, Text } from "@aws-amplify/ui-react";
export default function ProductCard2(props) {
  const { contents, overrides, ...rest } = props;
  const productCardTwoOnClick = useNavigateAction({
    type: "url",
    url: "/DetailAreaNew",
  });
  return (
    <Flex
      gap="0"
      direction="row"
      width="unset"
      height="unset"
      justifyContent="flex-start"
      alignItems="flex-start"
      position="relative"
      padding="0px 0px 0px 0px"
      onClick={() => {
        productCardTwoOnClick();
      }}
      {...getOverrideProps(overrides, "ProductCard2")}
      {...rest}
    >
      <Flex
        gap="0"
        direction="row"
        width="664px"
        height="unset"
        justifyContent="flex-start"
        alignItems="flex-start"
        shrink="0"
        position="relative"
        padding="0px 0px 0px 0px"
        backgroundColor="rgba(255,255,255,1)"
        {...getOverrideProps(overrides, "ProductCard1")}
      >
        <Image
          width="320px"
          height="unset"
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          shrink="0"
          alignSelf="stretch"
          position="relative"
          padding="0px 0px 0px 0px"
          objectFit="cover"
          src={contents?.FileSrc}
          {...getOverrideProps(overrides, "image")}
        ></Image>
        <Flex
          gap="24px"
          direction="column"
          width="unset"
          height="unset"
          justifyContent="flex-start"
          alignItems="flex-start"
          grow="1"
          shrink="1"
          basis="0"
          position="relative"
          padding="32px 32px 32px 32px"
          backgroundColor="rgba(255,255,255,1)"
          {...getOverrideProps(overrides, "Card Area")}
        >
          <Text
            fontFamily="Inter"
            fontSize="20px"
            fontWeight="700"
            color="rgba(13,26,38,1)"
            lineHeight="25px"
            textAlign="left"
            display="block"
            direction="column"
            justifyContent="unset"
            width="unset"
            height="unset"
            gap="unset"
            alignItems="unset"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children={contents?.Title}
            {...getOverrideProps(overrides, "Classic Long Sleeve T-Shirt")}
          ></Text>
          <Flex
            gap="16px"
            direction="row"
            width="unset"
            height="unset"
            justifyContent="flex-start"
            alignItems="center"
            shrink="0"
            position="relative"
            padding="0px 0px 0px 0px"
            {...getOverrideProps(overrides, "Tags")}
          >
            <Flex
              gap="10px"
              direction="row"
              width="unset"
              height="unset"
              justifyContent="center"
              alignItems="center"
              shrink="0"
              position="relative"
              borderRadius="32px"
              padding="6px 8px 6px 8px"
              backgroundColor="rgba(205,112,143,1)"
              {...getOverrideProps(overrides, "Badge39184155")}
            >
              <Text
                fontFamily="Inter"
                fontSize="12px"
                fontWeight="600"
                color="rgba(255,255,255,1)"
                lineHeight="12px"
                textAlign="left"
                display="block"
                direction="column"
                justifyContent="unset"
                width="unset"
                height="unset"
                gap="unset"
                alignItems="unset"
                shrink="0"
                position="relative"
                padding="0px 0px 0px 0px"
                whiteSpace="pre-wrap"
                children={contents?.Subject}
                {...getOverrideProps(overrides, "label39184156")}
              ></Text>
            </Flex>
            <Flex
              gap="10px"
              direction="row"
              width="unset"
              height="unset"
              justifyContent="center"
              alignItems="center"
              shrink="0"
              position="relative"
              borderRadius="32px"
              padding="6px 8px 6px 8px"
              backgroundColor="rgba(209,112,145,1)"
              {...getOverrideProps(overrides, "Badge39184159")}
            >
              <Text
                fontFamily="Inter"
                fontSize="12px"
                fontWeight="600"
                color="rgba(255,255,255,1)"
                lineHeight="12px"
                textAlign="left"
                display="block"
                direction="column"
                justifyContent="unset"
                width="unset"
                height="unset"
                gap="unset"
                alignItems="unset"
                shrink="0"
                position="relative"
                padding="0px 0px 0px 0px"
                whiteSpace="pre-wrap"
                children={contents?.Category}
                {...getOverrideProps(overrides, "label39184160")}
              ></Text>
            </Flex>
          </Flex>
          <Text
            fontFamily="Inter"
            fontSize="16px"
            fontWeight="400"
            color="rgba(13,26,38,1)"
            lineHeight="24px"
            textAlign="left"
            display="block"
            direction="column"
            justifyContent="unset"
            letterSpacing="0.01px"
            width="unset"
            height="unset"
            gap="unset"
            alignItems="unset"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children={contents?.Abstract}
            {...getOverrideProps(overrides, "Information about this product.")}
          ></Text>
          <Divider
            width="unset"
            height="1px"
            shrink="0"
            alignSelf="stretch"
            size="small"
            orientation="horizontal"
            {...getOverrideProps(overrides, "Divider")}
          ></Divider>
          <Flex
            gap="19px"
            direction="row"
            width="280px"
            height="36px"
            justifyContent="center"
            alignItems="flex-end"
            overflow="hidden"
            shrink="0"
            position="relative"
            padding="10px 10px 10px 10px"
            {...getOverrideProps(overrides, "Frame 39")}
          >
            <Flex
              gap="10px"
              direction="row"
              width="87px"
              height="25px"
              justifyContent="center"
              alignItems="center"
              overflow="hidden"
              shrink="0"
              position="relative"
              padding="10px 10px 10px 10px"
              backgroundColor="rgba(255,255,255,1)"
              {...getOverrideProps(overrides, "Frame 38")}
            >
              <Icon
                width="17px"
                height="16px"
                viewBox={{ minX: 0, minY: 0, width: 17, height: 16 }}
                paths={[
                  {
                    d: "M0.00317209 7.23074L-1.98926 7.40459L-1.98924 7.40483L0.00317209 7.23074ZM0.846071 6.31579L0.846071 4.31579L0.84557 4.31579L0.846071 6.31579ZM1.54553 16L1.54553 14L1.54503 14L1.54553 16ZM0.702203 15.2307L2.69463 15.0569L2.69461 15.0566L0.702203 15.2307ZM6.3867 6.07789L7.23622 7.8885L7.23663 7.88831L6.3867 6.07789ZM8.80918 4.20252L10.5222 5.23479L10.5223 5.23461L8.80918 4.20252ZM9.65166 0.50905L11.6497 0.598133L11.6497 0.59801L9.65166 0.50905ZM9.66182 0.310313L7.68097 0.0340849L7.67987 0.042189L9.66182 0.310313ZM11.9828 1.464L10.2693 2.49558L10.2701 2.49693L11.9828 1.464ZM12.3225 3.304L14.3187 3.42833L14.3188 3.42649L12.3225 3.304ZM11.932 5.07284L10.017 4.49604L10.0169 4.49619L11.932 5.07284ZM11.5596 6.30947L9.64454 5.73282C9.46216 6.33853 9.57707 6.99481 9.95441 7.50251C10.3318 8.01021 10.927 8.30947 11.5596 8.30947L11.5596 6.30947ZM16.1537 6.30947L16.1537 8.30947L16.1538 8.30947L16.1537 6.30947ZM16.9682 7.38021L18.8922 7.92624L18.8924 7.9257L16.9682 7.38021ZM14.6959 15.3869L16.6198 15.9334L16.62 15.933L14.6959 15.3869ZM13.881 16L13.8824 14L13.881 14L13.881 16ZM1.9956 7.05688C2.00968 7.21818 1.98987 7.38051 1.93764 7.53342L-1.84758 6.24031C-1.97531 6.61421 -2.02362 7.01074 -1.98926 7.40459L1.9956 7.05688ZM1.93764 7.53342C1.88541 7.6863 1.80205 7.82602 1.6934 7.94396L-1.24849 5.23374C-1.51565 5.52373 -1.71985 5.86643 -1.84758 6.24031L1.93764 7.53342ZM1.6934 7.94396C1.58477 8.06187 1.45329 8.1554 1.30763 8.21918L-0.296774 4.55504C-0.657142 4.71284 -0.98135 4.94376 -1.24849 5.23374L1.6934 7.94396ZM1.30763 8.21918C1.16199 8.28295 1.00502 8.31575 0.846573 8.31579L0.84557 4.31579C0.452549 4.31589 0.0635718 4.39726 -0.296774 4.55504L1.30763 8.21918ZM0.846071 8.31579L2.46205 8.31579L2.46205 4.31579L0.846071 4.31579L0.846071 8.31579ZM2.46205 8.31579C2.15925 8.31579 1.86687 8.19619 1.64976 7.98014L4.47117 5.14472C3.93664 4.61283 3.21375 4.31579 2.46205 4.31579L2.46205 8.31579ZM1.64976 7.98014C1.43231 7.76377 1.30834 7.46819 1.30834 7.15789L5.30834 7.15789C5.30834 6.40091 5.00604 5.67695 4.47117 5.14472L1.64976 7.98014ZM1.30834 7.15789L1.30834 15.1579L5.30834 15.1579L5.30834 7.15789L1.30834 7.15789ZM1.30834 15.1579C1.30834 14.8476 1.4323 14.552 1.64976 14.3356L4.47117 17.1711C5.00604 16.6388 5.30834 15.9149 5.30834 15.1579L1.30834 15.1579ZM1.64976 14.3356C1.86687 14.1196 2.15926 14 2.46205 14L2.46205 18C3.21374 18 3.93664 17.703 4.47117 17.1711L1.64976 14.3356ZM2.46205 14L1.54553 14L1.54553 18L2.46205 18L2.46205 14ZM1.54503 14C1.83084 13.9999 2.10794 14.1064 2.32129 14.301L-0.374398 17.2562C0.151225 17.7357 0.836589 18.0002 1.54602 18L1.54503 14ZM2.32129 14.301C2.53492 14.4959 2.66919 14.7653 2.69463 15.0569L-1.29023 15.4046C-1.22814 16.1161 -0.900297 16.7765 -0.374398 17.2562L2.32129 14.301ZM2.69461 15.0566L1.99558 7.05664L-1.98924 7.40483L-1.29021 15.4048L2.69461 15.0566ZM7.84719 6.89473C7.84719 7.39576 7.54591 7.7432 7.23622 7.8885L5.53717 4.26728C4.58854 4.71238 3.84719 5.68971 3.84719 6.89473L7.84719 6.89473ZM7.23663 7.88831C7.64701 7.69565 8.22928 7.39371 8.80722 6.98825C9.3632 6.59818 10.0487 6.0206 10.5222 5.23479L7.09616 3.17026C7.03357 3.27413 6.85668 3.47045 6.50989 3.71375C6.18506 3.94165 5.82414 4.13256 5.53676 4.26748L7.23663 7.88831ZM10.5223 5.23461C11.069 4.32718 11.3224 3.21451 11.4537 2.43638C11.5941 1.60459 11.6372 0.878909 11.6497 0.598133L7.65365 0.419967C7.64501 0.613718 7.61234 1.1613 7.50949 1.77087C7.39758 2.43412 7.24036 2.93092 7.09606 3.17043L10.5223 5.23461ZM11.6497 0.59801C11.6506 0.578219 11.6512 0.560345 11.6516 0.545309C11.6521 0.530436 11.6524 0.516999 11.6527 0.506898C11.6528 0.501884 11.6529 0.496884 11.653 0.493066C11.6531 0.488932 11.6532 0.485761 11.6532 0.482825C11.6534 0.47691 11.6535 0.47425 11.6535 0.473142C11.6535 0.472171 11.6535 0.474052 11.6533 0.477903C11.6531 0.481802 11.6528 0.488412 11.6522 0.497129C11.651 0.514277 11.6486 0.542497 11.6438 0.578438L7.67987 0.042189C7.66182 0.175611 7.65737 0.287966 7.65553 0.34559C7.65466 0.372807 7.65401 0.403331 7.65382 0.41144C7.65348 0.425489 7.65342 0.425069 7.65364 0.420091L11.6497 0.59801ZM11.6426 0.58654C11.609 0.827795 11.4842 1.2278 11.111 1.56537C10.743 1.89831 10.3387 1.98439 10.0978 1.99777C9.87226 2.01029 9.72537 1.96648 9.69413 1.95681C9.65167 1.94368 9.64889 1.93788 9.68584 1.95783C9.89608 2.07134 10.1682 2.32756 10.2693 2.49558L13.6962 0.432411C13.1859 -0.415148 12.3549 -1.14692 11.5862 -1.56194C11.2398 -1.74892 10.6103 -2.03686 9.87595 -1.99608C9.45981 -1.97296 8.90737 -1.83495 8.42773 -1.40109C7.943 -0.962623 7.74329 -0.412747 7.68098 0.0340872L11.6426 0.58654ZM10.2701 2.49693C10.2599 2.47989 10.2899 2.52457 10.3121 2.67329C10.3334 2.81667 10.3379 2.99231 10.3263 3.18151L14.3188 3.42649C14.3601 2.75276 14.3508 1.5178 13.6954 0.431066L10.2701 2.49693ZM10.3264 3.17967C10.3057 3.51216 10.2056 3.86978 10.017 4.49604L13.847 5.64964C14.0079 5.11548 14.2641 4.3051 14.3187 3.42833L10.3264 3.17967ZM10.0169 4.49619L9.64454 5.73282L13.4747 6.88612L13.847 5.64949L10.0169 4.49619ZM11.5596 8.30947L16.1537 8.30947L16.1537 4.30947L11.5596 4.30947L11.5596 8.30947ZM16.1538 8.30947C15.9772 8.30948 15.8026 8.2688 15.6436 8.19015L17.4173 4.60491C17.0242 4.41041 16.5917 4.30945 16.1535 4.30947L16.1538 8.30947ZM15.6436 8.19015C15.4846 8.11148 15.3451 7.99675 15.2367 7.85423L18.4202 5.43241C18.154 5.08241 17.8105 4.79942 17.4173 4.60491L15.6436 8.19015ZM15.2367 7.85423C15.1283 7.71167 15.054 7.54531 15.0203 7.36805L18.9503 6.62281C18.8682 6.18986 18.6865 5.78245 18.4202 5.43241L15.2367 7.85423ZM15.0203 7.36805C14.9867 7.19079 14.9949 7.00816 15.044 6.83471L18.8924 7.9257C19.0126 7.50181 19.0324 7.05578 18.9503 6.62281L15.0203 7.36805ZM15.0442 6.83418L12.7719 14.8409L16.62 15.933L18.8922 7.92624L15.0442 6.83418ZM12.7721 14.8404C12.8415 14.5958 12.9889 14.3824 13.1896 14.2314L15.5942 17.4279C16.0891 17.0556 16.45 16.5312 16.6198 15.9334L12.7721 14.8404ZM13.1896 14.2314C13.3902 14.0805 13.6334 13.9998 13.8824 14L13.8796 18C14.4973 18.0004 15.0994 17.8001 15.5942 17.4279L13.1896 14.2314ZM13.881 14L6.69347 14L6.69347 18L13.881 18L13.881 14ZM6.69347 14C6.99627 14 7.28865 14.1196 7.50577 14.3356L4.68435 17.1711C5.21889 17.703 5.94178 18 6.69347 18L6.69347 14ZM7.50577 14.3356C7.72322 14.552 7.84719 14.8476 7.84719 15.1579L3.84719 15.1579C3.84719 15.9149 4.14948 16.6388 4.68435 17.1711L7.50577 14.3356ZM7.84719 15.1579L7.84719 6.89473L3.84719 6.89473L3.84719 15.1579L7.84719 15.1579Z",
                    stroke: "rgba(209,112,145,1)",
                    fillRule: "nonzero",
                    strokeLinejoin: "round",
                    strokeWidth: 4,
                  },
                  {
                    d: "M0.00317209 7.23074C-0.00697335 7.11446 0.00728056 6.99736 0.0450295 6.88686C0.0827784 6.77636 0.143198 6.67488 0.222454 6.58885C0.301711 6.50282 0.398073 6.43412 0.505427 6.38711C0.612781 6.34011 0.728783 6.31582 0.846071 6.31579L2.46205 6.31579C2.6865 6.31579 2.90176 6.40451 3.06046 6.56243C3.21917 6.72036 3.30834 6.93455 3.30834 7.15789L3.30834 15.1579C3.30834 15.3812 3.21917 15.5954 3.06046 15.7534C2.90176 15.9113 2.6865 16 2.46205 16L1.54553 16C1.33371 16 1.12958 15.9211 0.973446 15.7786C0.817311 15.6362 0.720525 15.4407 0.702203 15.2307L0.00317209 7.23074ZM5.84719 6.89473C5.84719 6.54274 6.06722 6.22779 6.3867 6.07789C7.08446 5.75031 8.27306 5.09221 8.80918 4.20252C9.50018 3.05558 9.6305 0.983577 9.65166 0.50905C9.65462 0.442524 9.65293 0.375998 9.66182 0.310313C9.77649 -0.512002 11.3713 0.448419 11.9828 1.464C12.3149 2.01473 12.3572 2.73852 12.3225 3.304C12.2849 3.90863 12.1067 4.49263 11.932 5.07284L11.5596 6.30947L16.1537 6.30947C16.2844 6.30946 16.4134 6.3396 16.5305 6.39753C16.6476 6.45545 16.7496 6.53958 16.8285 6.64332C16.9074 6.74706 16.9611 6.86758 16.9853 6.99543C17.0096 7.12328 17.0037 7.25499 16.9682 7.38021L14.6959 15.3869C14.6458 15.5635 14.539 15.719 14.3919 15.8296C14.2448 15.9403 14.0654 16.0001 13.881 16L6.69347 16C6.46902 16 6.25377 15.9113 6.09506 15.7534C5.93635 15.5954 5.84719 15.3812 5.84719 15.1579L5.84719 6.89473Z",
                    fill: "rgba(209,112,145,1)",
                    fillRule: "nonzero",
                  },
                ]}
                display="block"
                gap="unset"
                alignItems="unset"
                justifyContent="unset"
                shrink="0"
                position="relative"
                {...getOverrideProps(overrides, "Vector4040190")}
              ></Icon>
              <Text
                fontFamily="Inter"
                fontSize="16px"
                fontWeight="400"
                color="rgba(0,0,0,1)"
                lineHeight="24px"
                textAlign="left"
                display="block"
                direction="column"
                justifyContent="unset"
                letterSpacing="0.01px"
                width="unset"
                height="unset"
                gap="unset"
                alignItems="unset"
                shrink="0"
                position="relative"
                padding="0px 0px 0px 0px"
                whiteSpace="pre-wrap"
                children="30"
                {...getOverrideProps(overrides, "304040188")}
              ></Text>
            </Flex>
            <Flex
              gap="10px"
              direction="row"
              width="87px"
              height="25px"
              justifyContent="center"
              alignItems="center"
              overflow="hidden"
              shrink="0"
              position="relative"
              padding="1px 13px 1px 13px"
              backgroundColor="rgba(255,255,255,1)"
              {...getOverrideProps(overrides, "Frame 37")}
            >
              <Icon
                width="14.5px"
                height="18px"
                viewBox={{
                  minX: 0,
                  minY: 0,
                  width: 14.502334594726562,
                  height: 18,
                }}
                paths={[
                  {
                    d: "M0 18L0 2C0 1.45 0.203033 0.979002 0.609098 0.587002C1.01516 0.195002 1.50272 -0.000664969 2.07176 1.69779e-06L12.4306 1.69779e-06C13.0003 1.69779e-06 13.4882 0.196002 13.8943 0.588002C14.3003 0.980002 14.503 1.45067 14.5023 2L14.5023 18L7.25117 15L0 18Z",
                    fill: "rgba(205,112,143,1)",
                    fillRule: "nonzero",
                  },
                ]}
                display="block"
                gap="unset"
                alignItems="unset"
                justifyContent="unset"
                shrink="0"
                position="relative"
                {...getOverrideProps(overrides, "Vector4040183")}
              ></Icon>
              <Text
                fontFamily="Inter"
                fontSize="16px"
                fontWeight="400"
                color="rgba(0,0,0,1)"
                lineHeight="24px"
                textAlign="left"
                display="block"
                direction="column"
                justifyContent="unset"
                letterSpacing="0.01px"
                width="unset"
                height="unset"
                gap="unset"
                alignItems="unset"
                shrink="0"
                position="relative"
                padding="0px 0px 0px 0px"
                whiteSpace="pre-wrap"
                children="30"
                {...getOverrideProps(overrides, "304040185")}
              ></Text>
            </Flex>
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
}
